import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AccordionCard/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/BriefBoxes/style.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ErrorState/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/InfoBanks/style.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/InfoDescribed/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/InfoPainels/style.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ProductForm/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ProsAndCons/style.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/ProductDetailsInfo/style.module.css");
